import { pluginApiUrlMap } from '@/api/url';
import { badage_api } from '@/api/api/user';

export const afterLoginSuccess = [];
export const afterLoginFail = [];

export function addLoginEvent(success, fail) {
  if (typeof success === 'function') {
    afterLoginSuccess.push(success);
  }
  if (typeof fail === 'function') {
    afterLoginFail.push(fail);
  }
}

export function clearLoginEvent() {
  if (afterLoginSuccess.length) afterLoginSuccess.splice(0, afterLoginSuccess.length);
  if (afterLoginFail.length) afterLoginFail.splice(0, afterLoginFail.length);
}

export async function handlePraise(params) {
  if (!params.res_id) return Promise.reject();
  if (!params.res_type) params.res_type = 0;
  let res
  try {
    res = await window.$nuxt.$axios.$post('/community/api/favorite', params);
  } catch (e) {
    if (e?.response?.status === 401) {
      return new Promise((resolve, reject) => {
        addLoginEvent(() => {
          handlePraise(params).then(resolve, reject);
        }, reject);
      });
    }
    return Promise.reject(e);
  }

  if (!window.localStorage.getItem('SHOWED_SAVE_GUIDE')) {
    window.$nuxt.$store.dispatch('user/handleHeadGuide', params.res_type ? 1 : 2);
    window.localStorage.setItem('SHOWED_SAVE_GUIDE', '1');
  }
  return res;
}

export async function handleCopy(res_id, org_id) {
  if (!res_id) return Promise.reject();
  const mastergoCopyParams = {
    resId: res_id,
    organizationId: org_id,
  };
  try {
    Object.assign(mastergoCopyParams, JSON.parse(localStorage.getItem('_MG_PROMOTE')))
  } catch (e) {
    console.warn(e);
  }

  const matergoCopyUrl = `/api/v1/community/resource/duplicate`;
  let res
  try {
    res = await window.$nuxt.$axios.$post(matergoCopyUrl, mastergoCopyParams);
    await window.$nuxt.$axios.$post('/community/api/copy-success', { res_id });
    handleBadge();
  } catch (e) {
    if (e?.response?.status === 401) {
      return new Promise((resolve, reject) => {
        addLoginEvent(() => {
          handleCopy(res_id).then(resolve, reject);
        }, reject);
      });
    }
    return Promise.reject(e);
  }
  return res;
}

// 徽章发送创建action
export async function handleBadge() {
  try {
    const fname = 'webapi.enablebadgev2';
    const experimentRes = await window.$nuxt.$axios.$post('/api/v1/experiment/var/user', {
      fname,
    });
    const experiment = experimentRes.data;

    // 判断是否命中徽章实验
    const isExper = experiment[fname] && experiment[fname].value === 'c1';

    if (isExper) {
      await window.$nuxt.$axios.$post(badage_api.badage_action, {
        action: 'copy_resource',
      });
    }
  } catch (error) {
    // nothing
  }
}

export async function downloadApi(plugin_id) {
  if (!plugin_id) return Promise.reject();
  const mastergoDownLoadParams = {
    plugin_id,
  };
  const mastegoDownLoadUrl = pluginApiUrlMap.pluginInstall;
  let res
  try {
    res = await window.$nuxt.$axios.$post(mastegoDownLoadUrl, mastergoDownLoadParams)
  } catch (e) {
    if (e?.response?.status === 401) {
      return new Promise((resolve, reject) => {
        addLoginEvent(() => {
          downloadApi(plugin_id).then(resolve, reject);
        }, reject);
      });
    }
    return Promise.reject(e);
  }
  return res
};
